// extracted by mini-css-extract-plugin
export var backButton = "component-module--backButton--00a43";
export var boldText = "component-module--boldText--87011";
export var bounce = "component-module--bounce--9cada";
export var cookieDescription = "component-module--cookieDescription--a2368";
export var cookieItemContent = "component-module--cookieItemContent--e08e8";
export var cookieItemHeader = "component-module--cookieItemHeader--62a9c";
export var cookieItemWrapper = "component-module--cookieItemWrapper--cf876";
export var fadeIn = "component-module--fadeIn--822ac";